import React, { useContext, useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import Fade from 'react-reveal/Fade';
import PortfolioContext from '../../context/context';
import IconButton from '../Buttons/IconButton';
import Typewriter from 'typewriter-effect';
import ScrollLine from '../ScrollLine';
import { ReactIcon, ReduxIcon, VueIcon, FlutterIcon, GatIcon } from '../SvgComponents/workIcons';
import Splitting from 'splitting';
import { useWindowSize  } from '@react-hook/window-size';

const ResumeHero = (props) => {
  const { hero } = useContext(PortfolioContext);
  const { title, name, subtitle, cta } = hero;
  const [width, height] = useWindowSize();
  const [isDesktop, setIsDesktop] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [opac, setOpac] = useState(0);

  useEffect(() => {
    if (width > 769) {
      setIsDesktop(true);
      setIsMobile(false);
    } else {
      setIsMobile(true);
      setIsDesktop(false);
    }
  }, []);

  const initiateCharAnimation = () => {
    const target = document.querySelector('#name-split');
    setOpac(1);
    Splitting({
      /* target: String selector, Element, Array of Elements, or NodeList */
      target: '[data-splitting]',
      /* by: String of the plugin name */
      by: 'chars',
      /* key: Optional String to prefix the CSS variables */
      key: null,
    });
  };

  useEffect(() => {
    initiateCharAnimation();
  }, []);

  return (
    <section id="hero" className="jumbotron">
      <Container className="px-0">
        <h1
          className="hero-title word-wrap"
          data-splitting={true}
          id="name-split"
          style={{ opacity: opac }}
        >
          {`Hi, I am ${width < 769 ? 'Zabi' : 'Mohammed Zabiullah'}`}
        </h1>

        <Fade left={isDesktop} bottom={isMobile} duration={1000} delay={1000} distance="30px">
          <Typewriter
            options={{
              strings: [
                'A developer & designer based in Bengaluru',
                'Developing experiences that matter',
                'Designing interfaces that inspire',
              ],
              autoStart: true,
              loop: true,
              delay: 30,
              deleteSpeed: 20,
              cursor: null,
              wrapperClassName: 'typewriter-custom',
            }}
          />
        </Fade>

        <div className="text-left mt-5 row hero-stack-icons">
          <Fade bottom duration={420} delay={1600} distance="60px">
            <div className="col" style={{ marginLeft: '-3px' }}>
              <IconButton svgIcon={ReactIcon} />
            </div>
          </Fade>
          <Fade bottom duration={420} delay={1800} distance="50px">
            <div className="col">
              <IconButton svgIcon={ReduxIcon} />
            </div>
          </Fade>
          <Fade bottom duration={420} delay={2000} distance="40px">
            <div className="col">
              <IconButton svgIcon={VueIcon} />
            </div>
          </Fade>
          <Fade bottom duration={420} delay={2200} distance="30px">
            <div className="col">
              <IconButton svgIcon={FlutterIcon} />
            </div>
          </Fade>
          <Fade bottom duration={420} delay={2400} distance="20px">
            <div className="col">
              <IconButton svgIcon={GatIcon} />
            </div>
          </Fade>
        </div>

        <div className="pt-5">
          <ScrollLine />
        </div>
      </Container>
    </section>
  );
};

export default ResumeHero;
